(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yhs-airport-collection-candidate"] && !Shopify.designMode) return;
  try {
    (() => {
  const refresh = () => {
    if (!document.querySelector('[data-yac-candidate]')) return;
    const params = new URLSearchParams(location.search);
    const preview = params.get('preview_theme_id') || window.Shopify?.theme?.role === 'unpublished' && window.Shopify?.theme?.id;
    const views = {'airport-service-counters':'yhs-airport-service-v11','airport-self-service-kiosk-housing':'yhs-airport-kiosk-v11','airport-check-in-counter-products':'yhs-airport-checkin-v11'};
    document.querySelectorAll('.yhs-airport-collection a[href]').forEach(link => {
      if (link.getAttribute('href').startsWith('#')) return;
      const url = new URL(link.getAttribute('href'), location.href);
      if (url.origin !== location.origin && !url.hostname.endsWith('.shopifypreview.com')) return;
      if (preview) {
        url.searchParams.set('preview_theme_id', preview);
        if (params.get('pb') === '0') url.searchParams.set('pb', '0');
        const handle = url.pathname.match(/^\/collections\/([^/]+)$/)?.[1];
        if (views[handle]) url.searchParams.set('view', views[handle]);
      }
      link.href = url.href;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once:true}); else refresh();
  document.addEventListener('shopify:section:load', refresh);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yhs-airport-collection-core"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yhs-airport-collection-explore')) {
  customElements.define('yhs-airport-collection-explore', class extends HTMLElement {
    connectedCallback() {
      this.update = this.update.bind(this);
      this.observer = new MutationObserver(this.update);
      const scope = this.closest('main') || this.parentElement;
      this.observer.observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'style', 'class'] });
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
    update() {
      const link = this.querySelector('a');
      const scope = this.closest('main') || document;
      const target = Array.from(scope.querySelectorAll('[data-yhs-airport-collection="configurations"]')).find(node => node.getClientRects().length > 0);
      if (!link) return;
      const href = target ? `#${target.id}` : this.dataset.fallback;
      if (href) {
        link.setAttribute('href', href);
        if (link.hidden) link.hidden = false;
      } else {
        link.removeAttribute('href');
        if (!link.hidden) link.hidden = true;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yhs-airport-collection-inquiry-context"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const panel = document.querySelector('[data-yac-inquiry]');
    if (!panel) return;
    const params = new URLSearchParams(location.search);
    const handle = params.get('yhs_collection');
    const titles = {'airport-service-counters':'Airport Service Counters','airport-self-service-kiosk-housing':'Airport Kiosk Housings'};
    if (!Object.hasOwn(titles, handle)) return;
    const configuration = (params.get('configuration') || '').slice(0,200);
    const key = `Collection: ${titles[handle]}`;
    const context = `${key}\nCollection URL: https://www.yhsfurniture.com/collections/${handle}${configuration ? '\nConfiguration: '+configuration : ''}\nRequest: Project drawing review`;
    panel.querySelector('[data-yac-context]').textContent = context;
    panel.hidden = false;
    let attempts = 0;
    const fill = () => {
      const fields = [...document.querySelectorAll('textarea[name="contact[body]"]')];
      document.querySelectorAll('shopify-forms-embed').forEach(host => {
        const field = host.shadowRoot?.querySelector('textarea[name="custom#project_details"]');
        if (field) fields.push(field);
      });
      let filled = false;
      fields.forEach(field => {
        if (field.dataset.yacContext === handle) { filled = true; return; }
        const original = field.value.trim();
        const value = original.includes(key) ? original : `${context}\n\n${original}`;
        Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype,'value').set.call(field,value);
        field.dispatchEvent(new Event('input',{bubbles:true,composed:true}));
        field.dispatchEvent(new Event('change',{bubbles:true,composed:true}));
        field.dataset.yacContext = handle;
        filled = field.value.includes(key);
      });
      if (filled) panel.querySelector('[data-yac-status]').textContent = 'Collection details added to your project enquiry.';
      else if (++attempts < 80) setTimeout(fill,500);
      else panel.querySelector('[data-yac-status]').textContent = 'Include the collection details above with your project information.';
    };
    fill();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yhs-airport-pdp-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const roots = [...document.querySelectorAll('[data-pdp-kind]')];
    if (!roots.length) return;
    roots.forEach(root => {
      if (root.dataset.pdpReady) return;
      root.dataset.pdpReady = 'true';
      root.addEventListener('click', event => {
        const thumb = event.target.closest('[data-pdp-thumb]');
        if (thumb) {
          const gallery = thumb.closest('[data-pdp-gallery]');
          gallery.querySelectorAll('[data-pdp-media]').forEach(media => {
            media.hidden = media.id !== thumb.dataset.pdpThumb;
            if (media.hidden) media.querySelectorAll('video').forEach(video => video.pause());
          });
          gallery.querySelectorAll('[data-pdp-thumb]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
        }
        const pin = event.target.closest('[data-pdp-pin]');
        if (pin) {
          const target = document.getElementById(pin.hash.slice(1));
          if (target) target.focus({ preventScroll: true });
        }
        const inquiry = event.target.closest('[data-pdp-inquiry]');
        if (inquiry) {
          const next = new URL(inquiry.href, location.href);
          const storeOrigin = new URL(inquiry.dataset.pdpStoreOrigin, location.href).origin;
          if (location.hostname.endsWith('.shopifypreview.com') && next.origin === storeOrigin) {
            next.host = location.host;
            next.protocol = location.protocol;
          }
          const preview = new URLSearchParams(location.search).get('preview_theme_id');
          if (preview && next.origin === location.origin) next.searchParams.set('preview_theme_id', preview);
          inquiry.href = next.href;
        }
      });
    });
    const kinds = ['overview', 'dimensions', 'interfaces', 'buildup', 'customization', 'review'];
    document.querySelectorAll('[data-pdp-nav]').forEach(nav => {
      const labels = nav.dataset.navLabels.split('|');
      const container = nav.firstElementChild;
      const links = kinds.flatMap((kind, index) => {
        const target = roots.find(root => root.dataset.pdpKind === kind && root.getClientRects().length);
        if (!target) return [];
        const link = document.createElement('a');
        link.href = `#${target.id}`;
        link.textContent = labels[index];
        return [link];
      });
      container.replaceChildren(...links);
      nav.hidden = !links.length;
    });
  };
  let queued = false;
  const measure = () => {
    queued = false;
    const nav = document.querySelector('[data-pdp-nav]:not([hidden])');
    if (!nav) return;
    const header = document.querySelector('.section-header');
    const rect = header?.getBoundingClientRect();
    const bottom = rect && rect.bottom > 0 && rect.top < innerHeight ? Math.min(rect.bottom, innerHeight / 2) : 0;
    document.documentElement.style.setProperty('--apdp-header-offset', `${Math.round(bottom)}px`);
    document.documentElement.style.setProperty('--apdp-nav-height', `${Math.round(nav.getBoundingClientRect().height)}px`);
    const links = [...nav.querySelectorAll('a')];
    let active = links[0];
    links.forEach(link => {
      const target = document.getElementById(link.hash.slice(1));
      if (target?.getBoundingClientRect().top <= bottom + nav.offsetHeight + 60) active = link;
    });
    links.forEach(link => {
      if (link === active) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(measure); } };
  const start = () => { init(); schedule(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(start));
  document.addEventListener('shopify:section:reorder', start);
  const observer = new ResizeObserver(schedule);
  document.querySelectorAll('.section-header, .announcement-bar-section').forEach(node => observer.observe(node));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yhs-airport-pdp-inquiry-context"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const panel = document.querySelector('[data-pdp-inquiry-context]');
    const params = new URLSearchParams(location.search);
    if (!panel || params.get('yhs_pdp') !== '1') return;
    const handle = params.get('product') || '';
    const id = params.get('product_id') || '';
    if (!/^[a-z0-9-]+$/.test(handle) || !/^\d+$/.test(id)) return;
    const title = (params.get('product_title') || handle).slice(0, 500);
    const productUrl = new URL(`/products/${encodeURIComponent(handle)}`, panel.dataset.storeOrigin).href;
    const labels = panel.dataset;
    const idLine = `${labels.labelId}: ${id}`;
    const values = [[labels.labelProduct, title], [labels.labelId, id], [labels.labelUrl, productUrl]];
    const reference = (params.get('configuration') || '').slice(0, 500);
    if (reference) values.push([labels.labelReference, reference]);
    values.push([labels.labelRequest, (params.get('intent') || 'drawings').slice(0, 100)]);
    const list = panel.querySelector('dl');
    list.replaceChildren();
    values.forEach(([name, value]) => {
      const dt = document.createElement('dt'); dt.textContent = name;
      const dd = document.createElement('dd'); dd.textContent = value;
      list.append(dt, dd);
    });
    panel.hidden = false;
    const context = values.map(([name, value]) => `${name}: ${value}`).join('\n');
    let attempts = 0;
    const fill = () => {
      const fields = [...document.querySelectorAll('textarea[name="contact[body]"]')];
      document.querySelectorAll('shopify-forms-embed').forEach(host => {
        const field = host.shadowRoot?.querySelector('textarea[name="custom#project_details"]');
        if (field) fields.push(field);
      });
      let filled = false;
      fields.forEach(field => {
        if (field.dataset.pdpContext === id) { filled = true; return; }
        const original = field.value.trim();
        const text = original.includes(idLine) ? original : `${context}\n\n${original}`;
        const setter = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value').set;
        setter.call(field, text);
        field.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
        field.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
        field.dataset.pdpContext = id;
        filled = field.value.includes(idLine);
      });
      const status = panel.querySelector('[data-pdp-context-status]');
      if (filled) status.textContent = labels.statusFilled;
      else if (++attempts < 80) setTimeout(fill, 500);
      else status.textContent = labels.statusFallback;
    };
    fill();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yhs-airport-v32-core"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yhs-a32-map')) {
  customElements.define('yhs-a32-map', class extends HTMLElement {
    connectedCallback() {
      this.img = this.querySelector('img');
      this.frame = this.querySelector('.a32-media');
      this.pins = this.querySelector('.a32-pins');
      this.update = () => {
        if (!this.img || !this.img.naturalWidth || !this.frame) { if(this.pins) this.pins.hidden=true; return; }
        this.pins.hidden=false;
        const {width:w,height:h}=this.frame.getBoundingClientRect();
        const s=getComputedStyle(this.img), iw=this.img.naturalWidth, ih=this.img.naturalHeight;
        const scale=s.objectFit==='cover'?Math.max(w/iw,h/ih):Math.min(w/iw,h/ih);
        const [px,py]=s.objectPosition.split(' ').map(v=>parseFloat(v)/100);
        Object.assign(this.pins.style,{width:`${iw*scale}px`,height:`${ih*scale}px`,left:`${(w-iw*scale)*(Number.isFinite(px)?px:.5)}px`,top:`${(h-ih*scale)*(Number.isFinite(py)?py:.5)}px`,right:'auto',bottom:'auto'});
        this.querySelectorAll('.a32-leader').forEach(svg=>{
          const label=[...this.querySelectorAll('.a32-pin,.a32-callout')].find(el=>el.dataset.blockId===svg.dataset.for);
          if(!label)return;
          const style=getComputedStyle(label), mobile=matchMedia('(max-width:749px)').matches;
          const read=(key,fallback)=>{const v=parseFloat(style.getPropertyValue(key));return Number.isFinite(v)?v:fallback;};
          const x=read(mobile?'--xm':'--x',read('--x',0)),y=read(mobile?'--ym':'--y',read('--y',0));
          const tx=read(mobile?'--txm':'--tx',read('--tx',0)),ty=read(mobile?'--tym':'--ty',read('--ty',0));
          const line=svg.querySelector('line'),dot=svg.querySelector('circle');
          for(const [key,value] of Object.entries({x1:x,y1:y,x2:tx,y2:ty}))line.setAttribute(key,value);
          dot.setAttribute('cx',tx);dot.setAttribute('cy',ty);
        });
      };
      this.observer=new ResizeObserver(this.update);this.observer.observe(this);
      this.img?.addEventListener('load',this.update);this.update();
      this.select=e=>{const pin=[...this.querySelectorAll('[data-block-id]')].find(p=>p.dataset.blockId===e.detail?.blockId);if(pin){pin.focus({preventScroll:true});pin.scrollIntoView({block:'center',behavior:'instant'});}};
      document.addEventListener('shopify:block:select',this.select);
    }
    disconnectedCallback(){this.observer?.disconnect();this.img?.removeEventListener('load',this.update);document.removeEventListener('shopify:block:select',this.select);}
  });
}
if (!window.yhsA32Explore) {
  window.yhsA32Explore=true;
  const update=()=>document.querySelectorAll('[data-a32-explore="true"]').forEach(a=>{
    if(!a.dataset.fallbackHref)a.dataset.fallbackHref=a.getAttribute('href');
    const target=document.querySelector('.a32--families');
    a.href=target?'#'+target.id:a.dataset.fallbackHref;
  });
  document.addEventListener('shopify:section:load',update);
  document.addEventListener('shopify:section:unload',()=>queueMicrotask(update));
  document.addEventListener('shopify:section:reorder',update);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',update,{once:true});else update();
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yhs-pdp-shared-shell"] && !Shopify.designMode) return;
  try {
    (() => {
  if (!document.querySelector('.apdp')) return;
  const observed = new WeakSet();
  const place = () => document.body.style.setProperty('--pdp-widget-offset', `${Math.max(0, Math.round(document.body.getBoundingClientRect().bottom - innerHeight))}px`);
  addEventListener('scroll', place, { passive: true });
  addEventListener('resize', place);
  new ResizeObserver(place).observe(document.body);
  place();
  const refresh = () => {
    const chat = document.querySelector('shopify-chat')?.shadowRoot;
    const tidio = document.querySelector('#tidio-chat')?.shadowRoot;
    const tidioButton = tidio?.querySelector('#button');
    const open = Boolean(chat?.querySelector('[aria-expanded="true"], shopify-agent-runtime[open]') || tidio?.querySelector('[role="log"], [aria-label="Close chat widget"]') || (tidioButton && !tidioButton.classList.contains('chat-closed')));
    document.body.toggleAttribute('data-pdp-chat-open', open);
    [chat, tidio].filter(Boolean).forEach(root => {
      if (observed.has(root)) return;
      observed.add(root);
      new MutationObserver(refresh).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-expanded', 'class', 'open'] });
    });
  };
  new MutationObserver(refresh).observe(document.body, { childList: true });
  let attempts = 0;
  const connect = () => {
    refresh();
    if (++attempts < 60 && (!document.querySelector('shopify-chat')?.shadowRoot || !document.querySelector('#tidio-chat')?.shadowRoot)) setTimeout(connect, 500);
  };
  connect();
})();
  } catch(e) { console.error(e); }
})();

})();
